// extracted by mini-css-extract-plugin
module.exports = {"Container":"AboutCard_Container__4XFZ_","Default":"AboutCard_Default__Ob9rP","Icon":"AboutCard_Icon__qem2r"};